// import React, { useState, useEffect, useRef } from 'react';
// import { Box, Typography, TextField, IconButton, Avatar, Alert,  Stack, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, ListItemText, ListItemIcon } from '@mui/material';
// import SendIcon from '@mui/icons-material/Send';
// import {
//     FormatItalic,
//     FormatBold,
//     StrikethroughS,
//     Code,
//     FormatQuote,
//     FormatListBulleted,
//     FormatListNumbered,
//   } from '@mui/icons-material';
// import PersonIcon from '@mui/icons-material/Person';
// import ChatIcon from '@mui/icons-material/Chat';
// import { useChatHistoryContext } from '../hooks/ChatHistoryProvider';

// import { blue } from '@mui/material/colors';
// import dayjs from "dayjs";
// import utc from "dayjs/plugin/utc";
// import EmojiPicker from 'emoji-picker-react';
// import timezone from "dayjs/plugin/timezone";
// import RefreshIcon from '@mui/icons-material/Refresh';
// import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
// import TranslateIcon from '@mui/icons-material/Translate';
// // import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
// import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
// import { CHAT_START_TOPIC_ENDPOINT, CHAT_END_TOPIC_ENDPOINT, CHAT_HISTORY_ENDPOINT } from '../config/urls';
// import Menu from '@mui/material/Menu';
// import MenuItem from '@mui/material/MenuItem';
// import Divider from '@mui/material/Divider';
// import Modal from '@mui/material/Modal';
// import ArrowRightIcon from '@mui/icons-material/ArrowRight';
// import { useAuth } from "../hooks/AuthProvider";

// // Initialize plugins
// dayjs.extend(utc);
// dayjs.extend(timezone);

// // Set default timezone
// dayjs.tz.setDefault("Asia/Kolkata");

// const ChatWindow = () => {
//     const { selectedUser, setChatHistory } = useChatHistoryContext();

//     console.log("Selected User ", selectedUser);

//     const [data, setData] = useState([]);
//     const [alertOpen, setAlertOpen] = useState(false);
//     const [inputValue, setInputValue] = useState("");
//     const [isEndChatModalOpen, setIsEndChatModalOpen] = useState(false);
//     const [selectedTone, setSelectedTone] = useState("");
//     const { getValidToken } = useAuth();
//     const socket = useRef(null);
//     const [modalOpen, setModalOpen] = useState(false);  
//     const [responseText, setResponseText] = useState("");
//     const [totalCreditLeft, setTotalCreditLeft] = useState(0);
//     const chatContainerRef = useRef(null);

//     const URL = process.env.NODE_ENV === 'production' ? 'api' : `http://localhost:8000/api`;
//     const NEWURL = process.env.NODE_ENV === 'production' ? '' : `http://localhost:8000`;

//     const adminSubscriberCode = localStorage.getItem("code");
//     const [open, setOpen] = React.useState(false);
//     const tenant = localStorage.getItem("tenant");

//     const parseMessage = (message) => {
//         // Replace markdown-like syntax with HTML tags
//         const formattedMessage = message
//             .replace(/_([^_]+)_/g, '<i>$1</i>') // Italic: _text_
//             .replace(/\*([^\*]+)\*/g, '<b>$1</b>') // Bold: *text*
//             .replace(/~([^~]+)~/g, '<s>$1</s>') // Strikethrough: ~text~
//             .replace(/`([^`]+)`/g, '<code>$1</code>'); // Strikethrough: ~text~

//         return formattedMessage;
//     };

//     useEffect(() => {
//         if (!selectedUser) return;
//         fetchChatHistory();
//     }, [selectedUser]);



//     const fetchChatHistory = async () => {
//         if (!selectedUser) return;

//         try {
//             const token = await getValidToken();
//             const response = await fetch(CHAT_HISTORY_ENDPOINT + "?search_query=" + selectedUser.sender, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     "X-tenant-ID": tenant
//                 },
//             });

//             if (!response.ok) throw new Error("Failed to fetch chat history");

//             const chatData = await response.json();
//             setData(chatData.data);
//         } catch (error) {
//             console.error("Error fetching chat history:", error);
//         }
//     };

//     useEffect(() => {
//         // Auto-scroll only when new messages arrive
//         if (chatContainerRef.current) {
//             chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
//         }
//     }, [data]);

//     return (
//         <Box display="flex" flexDirection="column" height="100%">
//             <Box padding={2} borderBottom="2px solid #ccc" display="flex" alignItems="center">
//                 <Avatar><PersonIcon /></Avatar>
//                 <Typography variant="h6" component="div" marginLeft={2} flexGrow={1}>
//                     {selectedUser ? `${selectedUser.name} +${selectedUser.sender}` : `Chat with User`}
//                 </Typography>
//                 {
//                 selectedUser ? (
//                 <Button
//                         variant="contained"
//                         color="primary"
//                         onClick={fetchChatHistory}
//                         startIcon={<RefreshIcon />}

//                     >
//                         Refresh
//                 </Button>
//                 ) : null
//                 }
//             </Box>
//             <Box flex="1" overflow="auto" padding={4} display="flex" flexDirection="column" sx={{ maxHeight: "calc(100vh - 200px)" }} >
//                     {data.length === 0 ? (
//                         // Center "No chat found" message
//                         <Box 
//                             display="flex" 
//                             flex="1" 
//                             justifyContent="center" 
//                             alignItems="center" 
//                             textAlign="center"
//                             ref={chatContainerRef}

//                         >
//                             <Box>
//                                 <ChatIcon sx={{ fontSize: 60, color: "gray" }} />
//                                 <Typography variant="h6" color="gray">No chat found</Typography>
//                             </Box>
//                         </Box>
//                     ) : (
//                         data.map((message, index) => (
//                             <Box key={index} marginBottom={2} display="flex" flexDirection={message.utype === "SPT" ? 'row-reverse' : 'row'}>
//                                 <Box maxWidth="70%" bgcolor={message.utype === "SPT" ? blue[500] : "#e0e0e0"} padding={1} borderRadius={3} position="relative" sx={{ wordBreak: 'break-word' }}>
//                                     <Stack spacing={0.5} direction="column">
//                                         <Typography wrap sx={{ fontSize: 14, textAlign: "left" }} color={message.utype === "SPT" ? "white" : "black"} dangerouslySetInnerHTML={{ __html: parseMessage(message.message) }} />
//                                         <Stack direction="row-reverse">
//                                             <Typography wrap sx={{ fontSize: 10 }} color={message.utype === "SPT" ? "white" : "black"}>{dayjs(message.timestamp).format('hh:mm A')}</Typography>
//                                         </Stack>
//                                     </Stack>
//                                 </Box>
//                             </Box>
//                         ))
//                     )}
//                 </Box>
//         </Box>
//     );
// };

// export default ChatWindow;

import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, Button, Avatar, Stack, useTheme, useMediaQuery, IconButton, Dialog } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import PersonIcon from '@mui/icons-material/Person';
import ChatIcon from '@mui/icons-material/Chat';
import { useChatHistoryContext } from '../hooks/ChatHistoryProvider';
import { blue } from '@mui/material/colors';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useAuth } from "../hooks/AuthProvider";
import { CHAT_HISTORY_ENDPOINT } from '../config/urls';
import { normalizePhoneDigitsForRequest } from '../utils/phoneSearch';
import { getTenantTimezone } from '../utils/dateUtils';
import { ArrowLeftIcon } from '@mui/x-date-pickers';
import { Close, LocationOn, OpenInNew, Phone, Reply } from '@mui/icons-material';

// Initialize plugins
dayjs.extend(utc);
dayjs.extend(timezone);

const parseMessage = (message) => {
    if (!message) return "";

    // Process code blocks first (with triple backticks)
    let formattedMessage = message.replace(/```(.+?)```/gs, '<pre><code>$1</code></pre>');

    // Find groups of bulleted list items and wrap them in <ul>
    formattedMessage = formattedMessage.replace(/(^|\n)((?:\s*[\*\-]\s+.+\n?)+)/g, function (match, p1, listBlock) {
        const listItems = listBlock.replace(/^\s*[\*\-]\s+(.+)$/gm, '<li>$1</li>');
        return p1 + '<ul>' + listItems + '</ul>';
    });

    // Find groups of numbered list items and wrap them in <ol>
    formattedMessage = formattedMessage.replace(/(^|\n)((?:\s*\d+\.\s+.+\n?)+)/g, function (match, p1, listBlock) {
        const listItems = listBlock.replace(/^\s*\d+\.\s+(.+)$/gm, '<li>$1</li>');
        return p1 + '<ol>' + listItems + '</ol>';
    });

    // Quote blocks
    formattedMessage = formattedMessage.replace(/^(\s*>\s+)(.+)$/gm, '<blockquote>$2</blockquote>');

    // Process inline elements
    formattedMessage = formattedMessage
        .replace(/_([^_]+)_/g, '<i>$1</i>') // Italic: _text_
        .replace(/\*([^\*]+)\*/g, '<b>$1</b>') // Bold: *text*
        .replace(/~([^~]+)~/g, '<s>$1</s>') // Strikethrough: ~text~
        .replace(/`([^`]+)`/g, '<code>$1</code>'); // Inline code: `text`

    formattedMessage = formattedMessage.replace(/\n/g, '<br>');

    return formattedMessage;
};

const outgoingBg = "#dcf8c6";
const incomingBg = "#e0e0e0";

const TemplateButton = ({ button, utype }) => {
    const buttonType = button.type;
    const buttonText = button.data.buttonText;

    return (
        <Box
            bgcolor={utype === "SPT" ? outgoingBg : incomingBg}
            padding={1}
            borderRadius={3}
            position="relative"
            sx={{
                mt: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "black",
                wordBreak: 'break-word',
                gap: 1
            }}
        >
            {buttonType === "custom" && <Reply fontSize='small' color="inherit" />}
            {buttonType === "call-phone-number" && <Phone fontSize='small' color="inherit" />}
            {buttonType === "visit-website" && <OpenInNew fontSize='small' color="inherit" />}
            {buttonType === "marketing-opt-out" && <Reply fontSize='small' color="inherit" />}
            <Typography
                wrap
                sx={{ fontSize: 14 }}
                color="inherit"
            >
                {buttonText}
            </Typography>
        </Box>
    )
}


export const TemplateMessage = ({ message }) => {
    const templateJson = message.template;
    const status = message.status || null;

    let body = templateJson.body;
    const bodyVariables = templateJson.sampleBodyFields;
    const parseArrayField = (value) => {
        if (Array.isArray(value)) return value;
        if (typeof value === "string" && value.trim()) {
            try {
                const parsed = JSON.parse(value);
                return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                return [];
            }
        }
        return [];
    };
    const buttons = parseArrayField(templateJson.allButtons);
    const carouselCards = parseArrayField(templateJson.carouselCards);
    const isCarouselTemplate =
        templateJson.marketingOption === "carousel" && carouselCards.length > 0;
    const mpmSections = parseArrayField(templateJson.mpmSections);
    const isMultiProductTemplate =
        templateJson.marketingOption === "multiple-products" ||
        templateJson.templateType === "PRODUCT";
    // mpmThumbnail / spmProduct are {title, retailerId, imageUrl}, stored as an object or JSON string
    const parseObjectField = (value) => {
        if (!value) return null;
        if (typeof value === "object") return value;
        try {
            return JSON.parse(value);
        } catch (e) {
            return null;
        }
    };
    const mpmThumbnail = parseObjectField(templateJson.mpmThumbnail);
    const isSingleProductTemplate =
        templateJson.marketingOption === "single-product" ||
        templateJson.templateType === "SPM";
    const spmProduct = parseObjectField(templateJson.spmProduct);
    const mpmItemCount = mpmSections.reduce(
        (total, section) => total + (Array.isArray(section?.products) ? section.products.length : 0),
        0,
    );
    const headerType = templateJson.headerType || "";
    const headerText = templateJson.headerText || "";
    const headerFile = templateJson.headerFile || "";
    const locationData = (() => {
        const rawLocation = templateJson.location;
        if (!rawLocation) return null;
        if (typeof rawLocation === "object") return rawLocation;
        if (typeof rawLocation === "string") {
            try {
                return JSON.parse(rawLocation);
            } catch (e) {
                return null;
            }
        }
        return null;
    })();

    const [mediaUrl, setMediaUrl] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [previewState, setPreviewState] = useState({
        open: false,
        items: [],
        index: 0,
    });

    const openImagePreview = (items, index = 0) => {
        if (!Array.isArray(items) || items.length === 0) return;
        setPreviewState({
            open: true,
            items,
            index,
        });
    };

    const closeImagePreview = () => {
        setPreviewState({ open: false, items: [], index: 0 });
    };

    const handlePreviewNavigate = (step) => {
        setPreviewState((prev) => {
            if (!prev.items.length) return prev;
            const total = prev.items.length;
            const nextIndex = (prev.index + step + total) % total;
            return { ...prev, index: nextIndex };
        });
    };

    const replaceVariables = (text, data) => {
        if (!text || !data || !Array.isArray(data)) return text;

        let replacedText = text;

        // Escape special regex characters in case they exist in the text
        for (let i = 0; i < data.length; i++) {
            // The pattern needs to match exactly {{1}}, {{2}}, etc.
            const pattern = "{{" + (i + 1) + "}}";

            // Simple string replacement
            replacedText = replacedText.replaceAll(
                pattern,
                `${data[i].value || i + 1}` || ""
            );
        }

        return replacedText;
    };

    const renderImage = (file) => {
        if (!file) return null;

        if (isLoading) {
            return <Box sx={{ textAlign: "center", mt: 2 }}>Loading image...</Box>;
        }

        const imageSource = typeof file === "string" ? mediaUrl || file : URL.createObjectURL(file);

        return (
            <Box
                component="img"
                src={imageSource}
                onClick={() => openImagePreview([{ src: imageSource, caption: "" }], 0)}
                sx={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                    borderRadius: 2,
                    cursor: "pointer",
                    maxWidth: 300
                }}
            />
        );
    };

    const renderVideo = (file) => {
        if (!file) return null;

        if (isLoading) {
            return <Box sx={{ textAlign: "center", mt: 2 }}>Loading video...</Box>;
        }

        const videoSource = typeof file === "string" ? mediaUrl || file : URL.createObjectURL(file);

        return (
            <Box
                component="video"
                controls
                preload="metadata"
                src={videoSource}
                sx={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                    borderRadius: 2,
                    maxWidth: 300,
                    backgroundColor: "#000",
                }}
            />
        );
    };

    const renderDocument = (file) => {
        if (!file) return null;
        const docSource = typeof file === "string" ? mediaUrl || file : URL.createObjectURL(file);

        return (
            <Button
                component="a"
                href={docSource}
                target="_blank"
                rel="noreferrer"
                variant="outlined"
                size="small"
                sx={{ alignSelf: "flex-start", textTransform: "none", mb: 1 }}
            >
                Open document
            </Button>
        );
    };

    const renderLocation = (location) => {
        if (!location) return null;

        const latitude = parseFloat(location.latitude);
        const longitude = parseFloat(location.longitude);
        const hasCoordinates =
            Number.isFinite(latitude) && Number.isFinite(longitude);
        const mapsUrl = hasCoordinates
            ? `https://www.google.com/maps?q=${latitude},${longitude}`
            : null;

        return (
            <Box
                sx={{
                    borderRadius: 2,
                    overflow: "hidden",
                    border: "1px solid #d9d9d9",
                    mb: 0.5,
                    maxWidth: 300,
                    backgroundColor: "#f8f8f8",
                }}
            >
                <Box
                    sx={{
                        height: 90,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#eceff1",
                    }}
                >
                    <LocationOn sx={{ color: "#d32f2f", fontSize: 34 }} />
                </Box>
                <Box sx={{ p: 1 }}>
                    {location.name ? (
                        <Typography sx={{ fontWeight: 600, fontSize: 13 }}>
                            {location.name}
                        </Typography>
                    ) : null}
                    {location.address ? (
                        <Typography sx={{ fontSize: 12, color: "#555" }}>
                            {location.address}
                        </Typography>
                    ) : null}
                    {mapsUrl ? (
                        <Button
                            component="a"
                            href={mapsUrl}
                            target="_blank"
                            rel="noreferrer"
                            size="small"
                            sx={{ mt: 0.5, p: 0, minWidth: 0, textTransform: "none" }}
                            endIcon={<OpenInNew sx={{ fontSize: 14 }} />}
                        >
                            View on map
                        </Button>
                    ) : null}
                </Box>
            </Box>
        );
    };

    const renderCarouselButton = (button, index) => {
        const buttonText = button?.data?.buttonText || button?.text || "Action";
        return (
            <Button
                key={`${buttonText}-${index}`}
                variant="text"
                size="small"
                sx={{
                    width: "100%",
                    justifyContent: "center",
                    textTransform: "none",
                    color: "#007bff",
                    borderTop: "1px solid #ececec",
                    borderRadius: 0,
                }}
            >
                {buttonText}
            </Button>
        );
    };

    const carouselImageItems = carouselCards
        .map((card, index) => {
            const image = templateJson[`cardFile_${index}`];
            const cardHeaderType = (card?.headerType || templateJson?.carouselType || "").toString().toUpperCase();
            return image && cardHeaderType === "IMAGE"
                ? { src: image, caption: card?.body || "" }
                : null;
        })
        .filter(Boolean);

    const renderCarousel = () => (
        <Stack spacing={1}>
            {templateJson.carouselMainBody ? (
                <Typography
                    wrap
                    sx={{ fontSize: 14, textAlign: "left" }}
                    color={"black"}
                    dangerouslySetInnerHTML={{
                        __html: parseMessage(replaceVariables(templateJson.carouselMainBody, templateJson.carouselMainBodySampleFields)),
                    }}
                />
            ) : null}
            <Box
                sx={{
                    display: "flex",
                    gap: 1,
                    overflowX: "auto",
                    pb: 0.5,
                    "&::-webkit-scrollbar": { height: 6 },
                }}
            >
                {carouselCards.map((card, index) => {
                    const cardMedia = templateJson[`cardFile_${index}`];
                    const cardHeaderType = (card?.headerType || templateJson?.carouselType || "").toString().toUpperCase();
                    const cardButtons = Array.isArray(card?.buttons) ? card.buttons : [];
                    return (
                        <Box
                            key={card.id || index}
                            sx={{
                                minWidth: 220,
                                maxWidth: 220,
                                borderRadius: 2,
                                border: "1px solid #ddd",
                                backgroundColor:
  message.utype === "SPT"
    ? outgoingBg
    : incomingBg,
                                overflow: "hidden",
                                flexShrink: 0,
                            }}
                        >
                            {cardHeaderType === "IMAGE" && cardMedia ? (
                                <Box
                                    component="img"
                                    src={cardMedia}
                                    onClick={() => {
                                        const itemIndex = carouselImageItems.findIndex(
                                            (item) => item.src === cardMedia,
                                        );
                                        openImagePreview(
                                            carouselImageItems,
                                            itemIndex >= 0 ? itemIndex : 0,
                                        );
                                    }}
                                    sx={{
                                        width: "100%",
                                        height: 140,
                                        objectFit: "cover",
                                        display: "block",
                                        cursor: "pointer",
                                    }}
                                />
                            ) : null}
                            {cardHeaderType === "VIDEO" && cardMedia ? (
                                <Box
                                    component="video"
                                    controls
                                    preload="metadata"
                                    src={cardMedia}
                                    sx={{
                                        width: "100%",
                                        height: 140,
                                        objectFit: "cover",
                                        display: "block",
                                        backgroundColor: "#000",
                                    }}
                                />
                            ) : null}
                            <Box sx={{ p: 1 }}>
                                <Typography
                                    sx={{ fontSize: 13, textAlign: "left" }}
                                    color="black"
                                >
                                    {card.body || ""}
                                </Typography>
                            </Box>
                            {cardButtons.map((button, buttonIndex) =>
                                renderCarouselButton(button, buttonIndex),
                            )}
                        </Box>
                    );
                })}
            </Box>
        </Stack>
    );

    const renderMultiProduct = () => (
        <Stack spacing={1}>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    p: 0.75,
                    borderRadius: 2,
                    backgroundColor: "rgba(0, 0, 0, 0.05)",
                }}
            >
                {mpmThumbnail?.imageUrl ? (
                    <Box
                        component="img"
                        src={mpmThumbnail.imageUrl}
                        alt={mpmThumbnail.title || ""}
                        onClick={() =>
                            openImagePreview([{ src: mpmThumbnail.imageUrl, caption: mpmThumbnail.title || "" }], 0)
                        }
                        sx={{
                            width: 56,
                            height: 56,
                            objectFit: "cover",
                            borderRadius: 1.5,
                            flexShrink: 0,
                            cursor: "pointer",
                        }}
                    />
                ) : null}
                <Box sx={{ minWidth: 0 }}>
                    {headerText ? (
                        <Typography sx={{ fontWeight: 700, fontSize: 14, color: "#000", lineHeight: 1.3 }}>
                            {replaceVariables(headerText, templateJson.sampleHeaderFields)}
                        </Typography>
                    ) : null}
                    <Typography sx={{ fontSize: 12, color: "#666" }}>
                        {mpmItemCount} {mpmItemCount === 1 ? "item" : "items"}
                    </Typography>
                </Box>
            </Box>
            <Typography
                wrap
                sx={{ fontSize: 14, textAlign: "left" }}
                color="black"
                dangerouslySetInnerHTML={{ __html: parseMessage(body) }}
            />
            {templateJson.footer ? (
                <Typography sx={{ fontSize: 12, color: "#888" }}>
                    {templateJson.footer}
                </Typography>
            ) : null}
        </Stack>
    );

    const renderSingleProduct = () => (
        <Stack spacing={1}>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    p: 0.75,
                    borderRadius: 2,
                    backgroundColor: "rgba(0, 0, 0, 0.05)",
                }}
            >
                {spmProduct?.imageUrl ? (
                    <Box
                        component="img"
                        src={spmProduct.imageUrl}
                        alt={spmProduct.title || ""}
                        onClick={() =>
                            openImagePreview([{ src: spmProduct.imageUrl, caption: spmProduct.title || "" }], 0)
                        }
                        sx={{
                            width: 56,
                            height: 56,
                            objectFit: "cover",
                            borderRadius: 1.5,
                            flexShrink: 0,
                            cursor: "pointer",
                        }}
                    />
                ) : null}
                <Typography sx={{ fontWeight: 700, fontSize: 14, color: "#000", lineHeight: 1.3, minWidth: 0 }}>
                    {spmProduct?.title || "View Product"}
                </Typography>
            </Box>
            <Typography
                wrap
                sx={{ fontSize: 14, textAlign: "left" }}
                color="black"
                dangerouslySetInnerHTML={{ __html: parseMessage(body) }}
            />
            {templateJson.footer ? (
                <Typography sx={{ fontSize: 12, color: "#888" }}>
                    {templateJson.footer}
                </Typography>
            ) : null}
        </Stack>
    );

    body = replaceVariables(body, bodyVariables);

    // Fetch media with headers when headerFile changes
    useEffect(() => {
        // Skip if no header file or it's not a string URL
        if (!headerFile || typeof headerFile !== "string") return;

        const tenant = localStorage.getItem("tenant");
        const headers = {
            "X-Tenant-Id": tenant,
        };

        const fetchMediaWithHeaders = async () => {
            setIsLoading(true);
            try {
                const response = await fetch(headerFile, { headers });
                if (!response.ok) throw new Error("Failed to fetch media");

                const blob = await response.blob();
                const objectUrl = URL.createObjectURL(blob);
                setMediaUrl(objectUrl);
            } catch (error) {
                console.error("Error fetching media:", error);
                // Fallback to direct URL if fetch fails
                setMediaUrl(headerFile);
            } finally {
                setIsLoading(false);
            }
        };

        // If headerType is a media type, fetch it
        if (
            headerType === "image" ||
            headerType === "video" ||
            headerType === "document" ||
            headerType === "gif"
        ) {
            fetchMediaWithHeaders();
        }

        // Cleanup function
        return () => {
            if (mediaUrl && mediaUrl.startsWith("blob:")) {
                URL.revokeObjectURL(mediaUrl);
            }
        };
    }, [headerFile, headerType]);

    return (
        <>
            <Box
                marginBottom={2}
                display="flex"
                flexDirection={message.utype === "SPT" ? 'row-reverse' : 'row'}
            >
                <Stack maxWidth="70%">

                    <Box
                        bgcolor={message.utype === "SPT" ? outgoingBg : incomingBg}
                        padding={1}
                        borderRadius={3}
                        position="relative"
                        sx={{ wordBreak: "break-word" }}
                    >
                        {isCarouselTemplate ? (
                            <Stack spacing={0.5} direction="column">
                                {renderCarousel()}
                                <Stack direction="row-reverse">
                                    <Typography
                                        wrap
                                        sx={{ fontSize: 10 }}
                                        color={"#888"}
                                    >
                                        {dayjs(message.timestamp).tz(getTenantTimezone()).format('MMM D YYYY hh:mm A')}{status ? ` | ${status.charAt(0).toUpperCase() + status.slice(1)}` : ""}
                                    </Typography>
                                </Stack>
                            </Stack>
                        ) : isSingleProductTemplate ? (
                            <Stack spacing={0.5} direction="column">
                                {renderSingleProduct()}
                                <Stack direction="row-reverse">
                                    <Typography
                                        wrap
                                        sx={{ fontSize: 10 }}
                                        color={"#888"}
                                    >
                                        {dayjs(message.timestamp).tz(getTenantTimezone()).format('MMM D YYYY hh:mm A')}{status ? ` | ${status.charAt(0).toUpperCase() + status.slice(1)}` : ""}
                                    </Typography>
                                </Stack>
                                {renderCarouselButton({ text: "View" }, 0)}
                            </Stack>
                        ) : isMultiProductTemplate ? (
                            <Stack spacing={0.5} direction="column">
                                {renderMultiProduct()}
                                <Stack direction="row-reverse">
                                    <Typography
                                        wrap
                                        sx={{ fontSize: 10 }}
                                        color={"#888"}
                                    >
                                        {dayjs(message.timestamp).tz(getTenantTimezone()).format('MMM D YYYY hh:mm A')}{status ? ` | ${status.charAt(0).toUpperCase() + status.slice(1)}` : ""}
                                    </Typography>
                                </Stack>
                                {renderCarouselButton({ text: "View items" }, 0)}
                            </Stack>
                        ) : (
                            <Stack spacing={0.5} direction="column">
                                {headerType === "image" && renderImage(headerFile)}
                                {headerType === "video" && renderVideo(headerFile)}
                                {headerType === "gif" && renderImage(headerFile)}
                                {headerType === "document" && renderDocument(headerFile)}
                                {headerType === "location" && renderLocation(locationData)}
                                {!["image", "video", "gif", "document", "location"].includes(headerType) && headerText ? (
                                    <Typography  sx={{ fontWeight: 700, fontSize: 15, mb: 0.5, color: "#000" }}>{headerText}</Typography>
                                ) : null}
                                <Typography
  wrap
  sx={{ fontSize: 14, textAlign: "left" }}
  color="black"
  dangerouslySetInnerHTML={{ __html: parseMessage(body) }}
/>
                                <Stack direction="row-reverse">
                                    <Typography
                                        wrap
                                        sx={{ fontSize: 10 }}
                                        color={"#888"}
                                    >
                                        {dayjs(message.timestamp).tz(getTenantTimezone()).format('MMM D YYYY hh:mm A')}{status ? ` | ${status.charAt(0).toUpperCase() + status.slice(1)}` : ""}
                                    </Typography>
                                </Stack>
                            </Stack>
                        )}
                    </Box>
                    {!isCarouselTemplate && !isMultiProductTemplate && !isSingleProductTemplate && buttons && buttons.length > 0 &&
                        buttons.map((button, index) => <TemplateButton key={index} button={button} utype={message.utype} />)
                    }
                </Stack>
            </Box>
            <Dialog
                open={previewState.open}
                onClose={closeImagePreview}
                fullScreen
                PaperProps={{
                    sx: {
                        backgroundColor: "#e9e9e9",
                    },
                }}
            >
                <Box sx={{ position: "relative", height: "100vh", display: "flex", flexDirection: "column" }}>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
                        <IconButton onClick={closeImagePreview}>
                            <Close />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative",
                            px: { xs: 2, md: 8 },
                        }}
                    >
                        {previewState.items.length > 1 ? (
                            <IconButton
                                onClick={() => handlePreviewNavigate(-1)}
                                sx={{
                                    position: "absolute",
                                    left: { xs: 8, md: 24 },
                                    backgroundColor: "rgba(0,0,0,0.2)",
                                    color: "#fff",
                                    "&:hover": { backgroundColor: "rgba(0,0,0,0.3)" },
                                }}
                            >
                                <ArrowLeftIcon />
                            </IconButton>
                        ) : null}
                        <Box
                            component="img"
                            src={previewState.items[previewState.index]?.src || ""}
                            sx={{
                                width: "100%",
                                maxHeight: "70vh",
                                objectFit: "contain",
                                display: "block",
                            }}
                        />
                        {previewState.items.length > 1 ? (
                            <IconButton
                                onClick={() => handlePreviewNavigate(1)}
                                sx={{
                                    position: "absolute",
                                    right: { xs: 8, md: 24 },
                                    backgroundColor: "rgba(0,0,0,0.2)",
                                    color: "#fff",
                                    transform: "rotate(180deg)",
                                    "&:hover": { backgroundColor: "rgba(0,0,0,0.3)" },
                                }}
                            >
                                <ArrowLeftIcon />
                            </IconButton>
                        ) : null}
                    </Box>
                    {previewState.items[previewState.index]?.caption ? (
                        <Typography
                            sx={{
                                px: 2,
                                pb: 1,
                                textAlign: "center",
                                color: "#666",
                                fontSize: 12,
                            }}
                        >
                            {previewState.items[previewState.index].caption}
                        </Typography>
                    ) : null}
                    {previewState.items.length > 1 ? (
                        <Box
                            sx={{
                                p: 1,
                                display: "flex",
                                gap: 1,
                                overflowX: "auto",
                                justifyContent: "center",
                                borderTop: "1px solid #ddd",
                                backgroundColor: "#f3f3f3",
                            }}
                        >
                            {previewState.items.map((item, idx) => (
                                <Box
                                    key={`${item.src}-${idx}`}
                                    component="img"
                                    src={item.src}
                                    onClick={() =>
                                        setPreviewState((prev) => ({ ...prev, index: idx }))
                                    }
                                    sx={{
                                        width: 46,
                                        height: 46,
                                        objectFit: "cover",
                                        borderRadius: 1,
                                        border:
                                            idx === previewState.index
                                                ? "2px solid #1e8e3e"
                                                : "2px solid transparent",
                                        cursor: "pointer",
                                        opacity: idx === previewState.index ? 1 : 0.8,
                                    }}
                                />
                            ))}
                        </Box>
                    ) : null}
                </Box>
            </Dialog>
        </>
    )
}

const ChatWindow = ({ setIsChatSelected }) => {
    const { selectedUser } = useChatHistoryContext();
    const [data, setData] = useState([]);
    const { getValidToken } = useAuth();
    const chatContainerRef = useRef(null);
    const tenant = localStorage.getItem("tenant");

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    useEffect(() => {
        if (!selectedUser) return;
        fetchChatHistory();
    }, [selectedUser]);

    const fetchChatHistory = async () => {
        if (!selectedUser) return;

        try {
            const token = await getValidToken();
            const rawSender = String(selectedUser.sender ?? "");
            const phoneQuery = encodeURIComponent(
              normalizePhoneDigitsForRequest(rawSender) || rawSender.replace(/\D/g, ""),
            );
            const response = await fetch(`${CHAT_HISTORY_ENDPOINT}?search_query=${phoneQuery}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "X-tenant-ID": tenant
                },
            });

            if (!response.ok) throw new Error("Failed to fetch chat history");

            const chatData = await response.json();
            setData(chatData.data);
        } catch (error) {
            console.error("Error fetching chat history:", error);
        }
    };

    useEffect(() => {
        // Auto-scroll only when new messages arrive
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    }, [data]);

    return (
        <Box display="flex" flexDirection="column" height="100%" width="100%" sx={{ backgroundColor: "#f5f5f5" }}>
            <Box sx={{ padding: { xs: 1, md: 2 } }} borderBottom="2px solid #ccc" display="flex" alignItems="center">
                {isMobile &&
                    <Box sx={{ margin: 0 }}>
                        <IconButton sx={{
                            width: 24,
                            height: 24,
                            fontSize: 16
                        }}
                            onClick={() => setIsChatSelected(false)}
                        >
                            <ArrowLeftIcon />
                        </IconButton>
                    </Box>
                }
                <Avatar
                    sx={{
                        width: { xs: 24, md: 40 },
                        height: { xs: 24, md: 40 },
                        fontSize: { xs: 16, md: 24 }
                    }}
                >
                    <PersonIcon fontSize="inherit" />
                </Avatar>
                <Typography variant={isMobile ? "body2" : "h6"} component="div" sx={{ marginLeft: { xs: 1, md: 2 } }} flexGrow={1}>
                    {selectedUser ? `${selectedUser.name} +${selectedUser.sender}` : `Chat with User`}
                </Typography>
                <Typography
                    variant='body2'
                    color="gray"
                >
                    Chats may take up to 2 minutes to sync
                </Typography>
            </Box>
            <Box
                ref={chatContainerRef}
                flex="1"
                overflow="auto"
                padding={isMobile ? 2 : 4}
                display="flex"
                flexDirection="column"
                sx={{ maxHeight: "calc(100vh - 200px)" }} // Adjust height if needed
            >
                {data.length === 0 ? (
                    <Box display="flex" flex="1" justifyContent="center" alignItems="center" textAlign="center">
                        <ChatIcon sx={{ fontSize: 60, color: "gray" }} />
                        <Typography variant="h6" color="gray">No chat found</Typography>
                    </Box>
                ) : (
                    data.map((message, index) => (
                        message.template ? <TemplateMessage key={index} message={message} /> :
                            <Box key={index} marginBottom={2} display="flex" flexDirection={message.utype === "SPT" ? 'row-reverse' : 'row'}>
                                <Box maxWidth="70%" bgcolor={message.utype === "SPT" ? "#dcf8c6" : "#e0e0e0"} padding={1} borderRadius={3} position="relative" sx={{ wordBreak: 'break-word' }}>
                                    <Stack spacing={0.5} direction="column">
                                        <Typography wrap sx={{ fontSize: 14, textAlign: "left" }} color={message.utype === "SPT" ? "white" : "black"} dangerouslySetInnerHTML={{ __html: parseMessage(message.message) }} />
                                        <Stack direction="row-reverse">
                                            <Typography wrap sx={{ fontSize: 10 }} color={message.utype === "SPT" ? "white" : "black"}>{dayjs(message.timestamp).tz(getTenantTimezone()).format('MMM D YYYY hh:mm A')}</Typography>
                                        </Stack>
                                    </Stack>
                                </Box>
                            </Box>
                    ))
                )}
            </Box>
        </Box>
    );
};

export default ChatWindow;
